<template lang='pug' src='./custom-invisalign-tabs.pug'></template>

<script>
import { showAccordion, showTab } from 'components/mixins'

export default {
  props: ['props'],
  mixins: [showAccordion, showTab]
}
</script>



// WEBPACK FOOTER //
// custom-invisalign-tabs.vue?37b36c96